module.exports = __webpack_public_path__ + "media/images/result_sets/icons/learned-36fe5499e27931fed95e6e86b51153d8.svg";